import { render, staticRenderFns } from "./EditConfirmationModal.vue?vue&type=template&id=24f5bd76"
import script from "./EditConfirmationModal.vue?vue&type=script&lang=js"
export * from "./EditConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports